export default __webpack_public_path__ + "static/media/Schneider-legrand2mob.979aedc8.jpg";